import { useState, useEffect, useCallback } from 'react';
import { getCookie } from '@/utils/cookies';

export const CLICKREF_PLACEHOLDER = '[clickref_lemon]';

export function getClickrefFromCookie(): string {
  if (typeof document === 'undefined') return 'seo';
  const stored = getCookie('clickref');
  if (stored && !stored.includes('gclid_value__msclkid_value')) {
    return stored;
  }
  return 'seo';
}

export function useClickref() {
  // null = SSR or before useEffect (keeps placeholder)
  const [clickref, setClickref] = useState<string | null>(null);

  useEffect(() => {
    // Deliberate post-hydration switch: reading the cookie during render would desynchronise the SSR
    // markup from the client one.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setClickref(getClickrefFromCookie());
  }, []);

  // For href - keeps placeholder if not yet hydrated
  const getClickrefUrl = useCallback(
    (url: string): string => {
      if (!url) return url;
      if (clickref === null) return url; // Keep [clickref_lemon] during SSR/hydration
      return url.replace(CLICKREF_PLACEHOLDER, encodeURIComponent(clickref));
    },
    [clickref]
  );

  // For onClick - always reads fresh cookie value
  const handleClickrefLink = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
      e.preventDefault();
      const freshClickref = getClickrefFromCookie();
      const finalUrl = url.replace(CLICKREF_PLACEHOLDER, encodeURIComponent(freshClickref));
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    },
    []
  );

  return { clickref, getClickrefUrl, handleClickrefLink };
}
